/* eslint-disable consistent-return */
/* eslint-disable radix */
const unit = [
  '',
  'one ',
  'two ',
  'three ',
  'four ',
  'five ',
  'six ',
  'seven ',
  'eight ',
  'nine ',
  'ten ',
  'eleven ',
  'twelve ',
  'thirteen ',
  'fourteen ',
  'fifteen ',
  'sixteen ',
  'seventeen ',
  'eighteen ',
  'nineteen ',
];
const dozens = ['', '', 'twenty', 'thirty', 'forty', 'fifty', 'sixty', 'seventy', 'eighty', 'ninety'];

export const digitInWords = (value) => {
  /* https://stackoverflow.com/questions/14766951/convert-digits-into-words-with-javascript */
  let num = value;
  // eslint-disable-next-line no-cond-assign
  if ((num = num.toString()).length > 9) return 'overflow';
  const n = `000000000${num}`.substr(-9).match(/^(\d{2})(\d{2})(\d{2})(\d{1})(\d{2})$/);
  if (!n) return '';
  let str = '';
  str += parseInt(n[1]) !== 0 ? `${unit[Number(n[1])] || `${dozens[n[1][0]]} ${unit[n[1][1]]}`}crore ` : '';
  str += parseInt(n[2]) !== 0 ? `${unit[Number(n[2])] || `${dozens[n[2][0]]} ${unit[n[2][1]]}`}lakh ` : '';
  str += parseInt(n[3]) !== 0 ? `${unit[Number(n[3])] || `${dozens[n[3][0]]} ${unit[n[3][1]]}`}thousand ` : '';
  str += parseInt(n[4]) !== 0 ? `${unit[Number(n[4])] || `${dozens[n[4][0]]} ${unit[n[4][1]]}`}hundred ` : '';
  str +=
    parseInt(n[5]) !== 0 ? (str ? 'and ' : '') + (unit[Number(n[5])] || `${dozens[n[5][0]]} ${unit[n[5][1]]}`) : '';
  return str.trimRight();
};

/**
 * To add sequence index inside parentheses ()
 * @param {string} strName string
 * @param {string array} dataList string array
 */
// e.g : Duplicating New Folder (1) with this function will give a suggestion name of New Folder (2)
export const sequenceName = (strName, dataList) => {
  if (strName) {
    const rcmnd = `${strName} (1)`;
    const regExp = /\(([^)]+)\)/;
    const matches = regExp.exec(strName);
    if (matches) {
      const reverseName = strName.split('').reverse().join(''); /// As long as you're dealing with simple ASCII characters
      const replaceFmtd = reverseName.replace(matches[1], '_').trim();
      const reverseBackName = replaceFmtd.split('').reverse().join('');

      const fmtd = reverseBackName;

      if (!Number.isNaN(matches[1]) && fmtd.substring(fmtd.length - 4, fmtd.length) === ' (_)') {
        const lastIdx = fmtd.length - 4;
        const prefix = fmtd.substring(0, lastIdx);

        if (dataList) {
          const arrSuffix = [];
          dataList.map((data) => {
            if (data.substring(0, lastIdx).toLowerCase() === prefix.toLowerCase()) {
              const mtc = regExp.exec(data);
              if (mtc && !Number.isNaN(mtc[1])) arrSuffix.push(Number(mtc[1]));
            }
            return data;
          });

          if (arrSuffix.length > 0) {
            return `${prefix} (${Number(Math.max(...arrSuffix) + 1)})`;
          }
        }
      }
    }
    return dataList.includes(rcmnd) ? sequenceName(rcmnd, dataList) : rcmnd;
  }
};

// Refactored the code so the behavior will be the same as the GenerateNewNameWithIndex function in BE.
// e.g : Duplicating New Folder (1) with this function will give a suggestion name of New Folder (1) (1)
export const sequenceNameIndexing = (strName, dataList) => {
  if (strName) {
    const regExp = /(\([1-9][0-9]*\))/;
    const filteredDataList = dataList.sort().filter((data) => data.startsWith(strName) && regExp.exec(data));
    const newPostFixes = [];
    const existingPostFixes = filteredDataList.map((data) => {
      const trimmedData = data.replace(strName, '').trimStart();

      return regExp.exec(trimmedData);
    });

    if (existingPostFixes.length > 0 && existingPostFixes[existingPostFixes.length - 1] !== null) {
      existingPostFixes.forEach((data) => {
        if (data) {
          const postfixNumber = Number(data.input.replace(/[()]|[\n]{2}/g, ''));
          if (postfixNumber) newPostFixes.push(postfixNumber);
        }
      });
    }

    const largestIndex = newPostFixes?.length ? Math.max(...newPostFixes) : 0;

    return `${strName} (${largestIndex + 1})`;
  }
};

export const checkContainIllegalChars = (name, param = /[|"<>?*%,!|\\:/\\]/g) =>
  // eslint-disable-next-line no-useless-escape
  name && name.match(param) !== null;

export const replaceString = (replacedString, param = /[|"<>?*%,!|\\:/\\]/g, replacedWith = '') =>
  replacedString.replace(param, replacedWith);

export const capitalize = (s) => {
  if (typeof s !== 'string') return '';
  if (s.length === 0) return '';
  return s.charAt(0).toUpperCase() + s.slice(1);
};

export const convertDateToLocale = (date) => {
  const now = new Date();
  const duration = now.getTime() - date.getTime();
  const days = Math.round(duration / (1000 * 60 * 60 * 24));
  if (days > 0) {
    return days > 1 ? `${days} days ago` : `${days} day ago`;
  }
  const result = date.toLocaleString([], {hour12: true, hour: '2-digit', minute: '2-digit'});
  // since firefox and chrome use different javascript engine (gecko vs v8), above line will return different string
  // (5:02 PM vs 05:02 PM), hence we need to reformat the time in case the user use firefox
  let hour = result.split(':')[0];
  if (hour.length === 1 && parseInt(hour) < 10) {
    hour = `0${hour}`;
  }
  let realResult = result.split(':');
  realResult[0] = hour;
  realResult = realResult.join(':');

  return realResult;
};

export const isNumberValue = (n) => {
  const value = `${n}`;
  return value.match(/[^$,.\d]/) === null;
};

export const getExtensionFromFile = (file) => {
  const ext = file.name.substring(file.name.lastIndexOf('.') + 1, file.name.length) || file.name;
  return ext;
};

export const convertDateToLicenseString = (date) => {
  const month = date.getUTCMonth() + 1 < 10 ? `0${date.getUTCMonth() + 1}` : date.getUTCMonth() + 1;
  const dateStr = date.getUTCDate() < 10 ? `0${date.getUTCDate()}` : date.getUTCDate();
  const dateString = `${month}/${dateStr}/${date.getUTCFullYear()}`;
  return dateString;
};

export const lowerCaseFirstLetter = (str) => {
  if (!str) return;

  return str[0].toLowerCase() + str.slice(1);
};

export const upperCaseFirstLetter = (str) => {
  if (!str) return;

  return str[0].toUpperCase() + str.slice(1);
};

export const removeParenthesesWrap = (n = '') => {
  let text = n;
  if (text?.length && text.startsWith('(') && text.endsWith(')')) {
    text = text.substring(1, text.length - 1);
  }
  return text;
};

export const isEmpty = (
  x, // don't put newline after return
) =>
  typeof x === 'undefined' ||
  x === null ||
  x === false || // same as: !x
  x.length === 0 ||
  x === 0 || // note this line, you might not need this.
  x === '' ||
  x.replace(/\s/g, '') === '' ||
  !/[^\s]/.test(x) ||
  /^\s*$/.test(x);

export const AllowedChar = ['a-z', 'A-Z', '0-9', '(', ')', '_'];
export const IncludeSymbolsMessage = (adition) =>
  `Allowed characters: '${[AllowedChar, adition].flat().join(' ')}', no space at start and only allow single space`;

const exceptEx = /[^\w()\s]/;
const exceptExAllowDot = /[^\w().\s]/;
const exceptExAllowDash = /[^\w()\-\s]/;
const exceptExAllowDotDash = /[^\w().\-\s]/;
export const exceptAllSpecialCharacters = /[^a-zA-Z0-9]/g;

const exceptMode = {
  default: 0,
  allowDot: 1,
  allowDash: 2,
  allowDotDash: 3,
};

/**
 * @param {string} string value to check.
 * @param {number} mode 0: default, 1: allowDot, 2: allowDash, 3: allowDotDash.
 * @return {boolean} a Boolean value that indicates whether or not it is include Symbols
 */
export const includeSymbols = (string, mode = 0) => {
  exceptEx.lastIndex = 0;
  let regex = exceptEx;

  switch (mode) {
    case exceptMode.allowDot:
      regex = exceptExAllowDot;
      break;
    case exceptMode.allowDash:
      regex = exceptExAllowDash;
      break;
    case exceptMode.allowDotDash:
      regex = exceptExAllowDotDash;
      break;
    default:
      break;
  }

  const result = regex.test(string) || string[0] === ' ' || string.includes('  ');

  return result;
};

export const isNullOrEmptyString = (value, checkDash = false) => {
  let result = false;

  result = value === '' || value === null || value === undefined;
  if (checkDash) result = result || value === '-';

  return result;
};

/**
 * @param {string} value value to validate.
 * @param {number} symbolsMode 0: default, 1: allowDot, 2: allowDash, 3: allowDotDash.
 * @return {string} message that indicates whether it is empty or include symbols, default value is null
 */
export const validateName = (value, symbolsMode) => {
  let message = null;

  if (isNullOrEmptyString(value)) {
    message = 'Cannot be empty';
  } else if (includeSymbols(value, symbolsMode)) {
    let adition = '';

    switch (symbolsMode) {
      case 1:
        adition = '.';
        break;
      case 2:
        adition = '-';
        break;
      case 3:
        adition = ['.', '-'];
        break;
      default:
        break;
    }

    message = IncludeSymbolsMessage(adition);
  }

  return message;
};

function camelize(str) {
  return str.replace(/(?:^\w|[A-Z]|\b\w|\s+)/g, (match, index) => {
    if (+match === 0) return ''; // or if (/\s+/.test(match)) for white spaces
    return index === 0 ? match.toLowerCase() : match.toUpperCase();
  });
}

export function enumToCamelCase(value) {
  return camelize(
    value
      .replace(/_/g, ' ')
      .replace(/\w+/g, (word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .replace(/\s+/g, ''),
  );
}

export function isAlphaNumeric(value) {
  const stringRegex = /^[a-zA-Z0-9]*$/;
  return stringRegex.test(value);
}
